/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_discount_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`25% off 100: you save 25, final price 75.`)
};

const es_pct_discount_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`25% de descuento sobre 100: ahorras 25, precio final 75.`)
};

const de_pct_discount_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`25 % Rabatt auf 100: du sparst 25, Endpreis 75.`)
};

const nl_pct_discount_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`25% korting op 100: je bespaart 25, eindprijs 75.`)
};

const fr_pct_discount_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`25 % de réduction sur 100 : vous économisez 25, prix final 75.`)
};

const it_pct_discount_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`25% di sconto su 100: risparmi 25, prezzo finale 75.`)
};

const pt_br2_pct_discount_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`25% de desconto em 100: você economiza 25, preço final 75.`)
};

const pt_pct_discount_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`25% de desconto em 100: poupa 25, preço final 75.`)
};

const ja_pct_discount_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100の25%オフ: 節約額25、最終価格75。`)
};

const zh_pct_discount_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 打 25% 折扣：节省 25，最终价格 75。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_discount_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_discount_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_discount_ex1", locale)
	if (locale === "en") return en_pct_discount_ex1(inputs)
	if (locale === "es") return es_pct_discount_ex1(inputs)
	if (locale === "de") return de_pct_discount_ex1(inputs)
	if (locale === "nl") return nl_pct_discount_ex1(inputs)
	if (locale === "fr") return fr_pct_discount_ex1(inputs)
	if (locale === "it") return it_pct_discount_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_pct_discount_ex1(inputs)
	if (locale === "pt") return pt_pct_discount_ex1(inputs)
	if (locale === "ja") return ja_pct_discount_ex1(inputs)
	return zh_pct_discount_ex1(inputs)
};